
import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';

interface QuizCardProps {
  question: string;
  description?: string;
  children: React.ReactNode;
  onNext: () => void;
  onPrevious: () => void;
  canProceed: boolean;
  isFirst?: boolean;
  isLast?: boolean;
  className?: string;
}

const QuizCard: React.FC<QuizCardProps> = ({
  question,
  description,
  children,
  onNext,
  onPrevious,
  canProceed,
  isFirst = false,
  isLast = false,
  className,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.4 }}
      className={cn("morgen-card max-w-3xl w-full mx-auto", className)}
    >
      <h2 className="text-xl md:text-2xl font-satoshi mb-2">{question}</h2>
      {description && (
        <p className="text-gray-600 mb-6">{description}</p>
      )}
      
      <div className="my-6">
        {children}
      </div>
      
      <div className="flex justify-between mt-8">
        <Button
          variant="outline"
          onClick={onPrevious}
          disabled={isFirst}
          className={cn("px-6", isFirst && "opacity-0 pointer-events-none")}
        >
          Previous
        </Button>
        
        <Button
          onClick={onNext}
          disabled={!canProceed}
          className={cn(
            "bg-morgen-gradient hover:opacity-90 text-white",
            !canProceed && "opacity-50 cursor-not-allowed"
          )}
        >
          {isLast ? "Complete" : "Next"}
        </Button>
      </div>
    </motion.div>
  );
};

export default QuizCard;
